import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const setIsNoteAddingAction = (state: ImageHandlingState, action: PayloadAction<boolean>) => {
	state.isNoteAdding = action.payload;
};